var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconMenu8 = function SvgIconMenu8(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "icon-menu-8_svg__a",
    width: 32,
    height: 32,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "m16 9-3-5h6l-3 5Zm3.332 7.792A3.335 3.335 0 0 1 15.316 20a3.332 3.332 0 0 1-1.162-6.038 3.333 3.333 0 0 1 1.845-.558 3.36 3.36 0 0 1 3.333 3.388ZM18 16.115h-1.333v-1.356h-1.333v1.356H14v1.355h1.333v1.355h1.333V17.47h1.333v-1.355Zm-2 10.885a10.07 10.07 0 0 1-9.908-8.827A10.184 10.184 0 0 1 13.357 7l1.221 2.483a7.344 7.344 0 0 0-5.889 7.92 7.346 7.346 0 0 0 12.244 4.727 7.346 7.346 0 0 0-3.514-12.647L18.639 7a10.181 10.181 0 0 1 7.266 11.173A10.074 10.074 0 0 1 15.999 27Zm3.687-13.036.933-.96a6.13 6.13 0 0 1 1.252 3.113h-1.32a4.774 4.774 0 0 0-.866-2.153Zm-3.027 7.511a4.507 4.507 0 0 0 2.093-.89l.934.959a5.786 5.786 0 0 1-3.027 1.288v-1.357Zm0-9.36V11.01l.116-.24a5.793 5.793 0 0 1 2.91 1.276l-.933.96a4.507 4.507 0 0 0-2.095-.892h.002Zm-3.414 8.47c.61.471 1.332.778 2.094.891v1.357a5.788 5.788 0 0 1-3.027-1.288l.933-.96Zm-.933-8.54a5.799 5.799 0 0 1 2.91-1.276l.116.24v1.105a4.506 4.506 0 0 0-2.093.89l-.933-.959Zm-2.185 5.428h1.32c.107.778.405 1.518.866 2.153l-.933.96a6.13 6.13 0 0 1-1.253-3.112Zm0-1.356a6.13 6.13 0 0 1 1.252-3.112l.933.959a4.776 4.776 0 0 0-.866 2.153h-1.32Zm11.744 1.356a6.127 6.127 0 0 1-1.252 3.112l-.933-.96c.461-.635.759-1.374.866-2.152h1.32Z",
    clipRule: "evenodd"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon-menu-8_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFC600",
    d: "M0 0h32v32H0z"
  }))));
};
export default SvgIconMenu8;